import {
	createReducer,
	createSlice,
	createAction,
	createAsyncThunk,
	createEntityAdapter,
} from '@reduxjs/toolkit';

import { API } from '../../api';


const INITIAL_REQUEST_STATE = { key: null,
								user: {},
								claimed_by: {},
								payment: {},
								contact: {}
							  };

export const fetchRequest = createAsyncThunk(
	"requests/fetchRequest",
	async (key, thunkAPI)  => {
		return API.fetchRequest(key);
	}
);

export const updateRequest = createAsyncThunk(
	"requests/updateRequest",	
	async (data, thunkAPI) => {
		return data;
	}
);

// Then, handle actions in your reducers:
const requestsSlice = createSlice({
	name: "requests",
	
	initialState: {
		byKey: {},
		current: INITIAL_REQUEST_STATE,
		loading: 'idle'
	},
	
	reducers: {
		setCurrentRequest: (state, action) => {
			console.warn("setting current request %o !!!", action);
			state.current = action.payload || INITIAL_REQUEST_STATE;
			if(action.payload)
				state.byKey[action.payload.key] = action.payload;
		},
	},
	
	extraReducers: {
		// // Add reducers for additional action types here, and handle loading state as needed
		[fetchRequest.fulfilled]: (state, action) => {
			// Add user to the state array
			state.current = action.payload;
			state.byKey[action.payload.key] = action.payload;
		},


		[updateRequest.fulfilled]:  (state, action) => {
			let request = action.payload;
			state.byKey[request.key] = request;
		},
		
		
	}
	
});


export const { setCurrentRequest } = requestsSlice.actions;
export default requestsSlice.reducer; 
